import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  query,
  where,
  getDocs,
} from '@angular/fire/firestore';
import { COLLECTIONS } from '../constants/collection.constants';


@Injectable({ providedIn: 'root' })
export class UserRoleService {

  constructor(private firestore: Firestore) {}

  async getUserRoleByEmailOrPhone(
    email: string,
    phoneNumber?: string
  ): Promise<any | null> {
    console.debug('[UserRoleService] getUserRoleByEmailOrPhone called with:', { email, phoneNumber });
    const usersRef = collection(this.firestore, COLLECTIONS.ADMINS);
    let q;
    if (phoneNumber && email) {
      console.debug('[UserRoleService] Querying by email and phoneNumber');
      q = query(
        usersRef,
        where('email', '==', email),
        where('phoneNumber', '==', phoneNumber)
      );
    } else if (phoneNumber) {
      console.debug('[UserRoleService] Querying by phoneNumber');
      q = query(usersRef, where('phoneNumber', '==', phoneNumber));
    } else if (email) {
      console.debug('[UserRoleService] Querying by email');
      q = query(usersRef, where('email', '==', email));
    }
    if (q) {
      const querySnapshot = await getDocs(q);
      console.debug('[UserRoleService] Query result empty:', querySnapshot.empty);
      if (!querySnapshot.empty) {
        console.debug('[UserRoleService] Returning user data:', querySnapshot.docs[0].data());
        // Return the first matching user document
        return querySnapshot.docs[0].data();
      }
    } else {
      console.debug('[UserRoleService] No query constructed');
    }
    return null;
  }
}
